import styled from 'styled-components';

export const AuthWrapper = styled.div`
  display: grid;
  grid-gap: 4rem;
  grid-template-areas:
    'logo'
    'content';
  grid-template-rows: min-content 1fr;
  height: 100%;
`;

export const Logo = styled.div`
  grid-area: logo;
`;

export const FormWrapper = styled.div`
  align-items: center;
  display: grid;
  grid-area: content;
  height: 100%;
  justify-items: center;
`;

export const FormContent = styled.div`
  max-width: 40rem;
  padding: 0 0 4rem;
  width: 100%;
`;

export const AlertContainer = styled.div`
  margin-bottom: 5rem;
`;

export const SubmitContainer = styled.div`
  margin-top: 1rem;

  & + & {
    margin-top: 3rem;
  }
`;

export const SubmitButtonContainer = styled.div`
  display: flex;
  align-items: center;

  > * {
    margin-right: 1rem;
  }
`;
